import { FormControl, InputLabel, OutlinedInput, TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import addGrayOutline from "../../../assets/img/add-gray-outline.svg";
import Drawer from "../../../components/Drawer";
import InputMask from "react-input-mask";

import MultipleSelectChip from "../../../components/inputs/MultipleSelectChip";
import MultipleCollaboratorsSelectChip from "../../../components/inputs/MultipleSelectChip/MultipleCollaboratorsSelectChip";
import MultipleServicesSelectChip from "../../../components/inputs/MultipleSelectChip/MultipleServicesSelectChip";
import MultipleDaysOfWeekSelectChip from "../../../components/inputs/MultipleSelectChip/MultipleDaysOfWeekSelectChip";
import Layout from "../../../components/Layout";
import api from "../../../config/api";
import CircleImage from "../../../components/Image/CircleImage";
import { useHistory } from "react-router-dom";
import WorkDayTabs from "./components/WorkDayTabs";
import { useAuth } from "../../../context/ContextApi";
import swal from "sweetalert";
import { Spinner } from "react-bootstrap";

export default function Collaborator() {
  const { userToken } = useAuth();
  const [load, setLoad] = useState(false);
  const [image, setImage] = useState({});
  const [collaboratorToUpdate, setCollaboratorToUpdate] = useState({
    name: "",
    services: [],
  });
  const [isCollaboratorLoading, setIsCollaboratorLoading] = useState(true);
  const collaboratorId = window.location.pathname.split("/").pop();
  let history = useHistory();
  const handleCollaboratorChange = (event) => {
    setCollaboratorToUpdate((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
  };

  const handleCollaboratorServicesChange = (newValues) => {
    // console.log("setting collabortor new values");
    // console.log(newValues);
    setCollaboratorToUpdate((values) => ({
      ...values,
      services: newValues,
    }));
  };
  const handleReturn = () => {
    history.goBack();
  };
  const handleSubmitCollaborator = async (e) => {
    setLoad(true);
    e.preventDefault();
    if (image.name) {
      try {
        const dataup = new FormData();
        const config = {
          headers: {
            Authorization: `Bearer ${userToken}`,
            "Content-Type": `multipart/form-data`,
          },
        };
        dataup.append("file", image);
        const response = await api.put(`/professional-avatar/${collaboratorToUpdate._id}`, dataup, config).then(() => {
          swal("Sucesso!", "Alterações realizadas com sucesso", "success");
          getProfessional();
        });
      } catch (error) {
        console.log("selectImageNewUser error", error.message);
      }
    }
    try {
      delete collaboratorToUpdate.avatar;
      const response = await api
        .put(`/professional-update/${collaboratorToUpdate._id}`, collaboratorToUpdate)
        .then(() => {
          swal("Sucesso!", "Alterações realizadas com sucesso", "success");
          getProfessional();
        });
    } catch (error) {
      console.log("handleSubmitCollaborator error", error.message);
    } finally {
      setLoad(false);
    }
  };
  const selectImageNewUser = (e) => {
    if ((e !== undefined) & (e !== null)) {
      if (e.target.files && e.target.files[0]) {
        setCollaboratorToUpdate((values) => ({
          ...values,
          avatar: URL.createObjectURL(e.target.files[0]),
        }));
        setImage(e.target.files[0]);
      }
    }
  };
  function handleSelecetedTags(items) {
    console.log(items);
  }

  const getProfessional = async () => {
    try {
      const {
        data: { professional },
      } = await api.get("/professional/" + collaboratorId);
      // console.log("professional");
      // console.log(professional);
      setCollaboratorToUpdate(professional);
    } catch (e) {
      console.error("Collaborator - getProfessional");
      console.error(e);
    } finally {
      setIsCollaboratorLoading(false);
    }
  };
  useEffect(() => {
    getProfessional();
  }, [collaboratorId]);

  return (
    <>
      <Layout defaultMenu={7} title={"Colaboradores"} link={"/colaboradores"}>
        <div className="store container-fluid px-lg-3 pt-1">
          <form onSubmit={(e) => handleSubmitCollaborator(e)}>
            <div className="d-flex flex-column h-100">
              <div className="d-flex align-items-center col-12 mt-2">
                <span className="text-cl-black ff-univanova-medium col-8 fz-20 me-auto">Foto do colaborador</span>
                <div className="add-collaborator-drawer-footer align-items-center d-flex justify-content-center">
                  {load ? (
                    <Spinner
                      animation="border"
                      className="align-items-center d-flex justify-content-center me-5"
                      role="status"
                    />
                  ) : (
                    <button type="submit" className="btn br-6 bg-gradient-theme-blue text-white px-4">
                      Salvar alterações
                    </button>
                  )}
                </div>
              </div>
              <label className="d-flex justify-content-center align-self-start flex-column c-pointer my-3">
                {collaboratorToUpdate?.avatar ? (
                  <CircleImage url={collaboratorToUpdate?.avatar} sizePx="100px" />
                ) : (
                  <img src={addGrayOutline} className=" add-collaborator-image-button" alt="" />
                )}

                <input type="file" id="file" name="avatar" onChange={(e) => selectImageNewUser(e)} className="d-none" />
              </label>

              <span className="text-cl-black ff-univanova-medium fz-20 mb-4 d-block">Informações gerais</span>
              <TextField
                onChange={(event) => handleCollaboratorChange(event)}
                value={collaboratorToUpdate?.name}
                required
                name="name"
                label={"Nome do profissional"}
                variant={"outlined"}
                // error={erroName}
                className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
                InputLabelProps={{ shrink: true }}
              />
              <MultipleServicesSelectChip
                values={collaboratorToUpdate.services}
                label="Serviços realizados pelo profissional *"
                handleCollaboratorServicesChange={handleCollaboratorServicesChange}
              />
            </div>
            <span className="text-cl-black ff-univanova-medium fz-20 mb-2 d-block">
              Dias e horário de trabalho do funcionário
            </span>
            <WorkDayTabs />
          </form>
        </div>
      </Layout>
    </>
  );
}
